<template>
  <div class="hero-visual" aria-hidden="true">
    <div class="hero-visual__glow"></div>
    <div class="hero-visual__orbit hero-visual__orbit--1"></div>
    <div class="hero-visual__orbit hero-visual__orbit--2"></div>
    <div class="hero-visual__orbit hero-visual__orbit--3"></div>

    <div class="hero-visual__core">
      <div class="hero-visual__core-inner">
        <span class="hero-visual__core-icon">AI</span>
        <span class="hero-visual__core-text">智慧政务</span>
      </div>
    </div>

    <div
      v-for="chip in chips"
      :key="chip.label"
      class="hero-visual__chip"
      :class="'hero-visual__chip--' + chip.pos"
    >
      <span class="hero-visual__chip-icon">{{ chip.icon }}</span>
      <span>{{ chip.label }}</span>
    </div>

    <svg class="hero-visual__chart" viewBox="0 0 280 120" fill="none">
      <rect x="20" y="70" width="28" height="40" rx="4" fill="rgba(0,163,255,0.5)" />
      <rect x="60" y="50" width="28" height="60" rx="4" fill="rgba(0,82,217,0.7)" />
      <rect x="100" y="30" width="28" height="80" rx="4" fill="rgba(0,163,255,0.9)" />
      <rect x="140" y="45" width="28" height="65" rx="4" fill="rgba(0,82,217,0.6)" />
      <rect x="180" y="20" width="28" height="90" rx="4" fill="rgba(0,163,255,0.8)" />
      <rect x="220" y="55" width="28" height="55" rx="4" fill="rgba(0,82,217,0.5)" />
      <path d="M20 110 H260" stroke="rgba(255,255,255,0.15)" stroke-width="1" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'HeroVisual',
  data() {
    return {
      chips: [
        { icon: '🤖', label: 'AI 赋能', pos: 'tl' },
        { icon: '📊', label: '数据治理', pos: 'tr' },
        { icon: '☁️', label: '云计算', pos: 'bl' },
        { icon: '🔒', label: '安全合规', pos: 'br' }
      ]
    }
  }
}
</script>

<style scoped>
.hero-visual {
  position: relative;
  width: 100%;
  max-width: 480px;
  height: 380px;
  margin: 0 auto;
}

.hero-visual__glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 280px;
  height: 280px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(0, 163, 255, 0.35) 0%, transparent 70%);
  filter: blur(20px);
  animation: pulse-glow 4s ease-in-out infinite;
}

.hero-visual__orbit {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.hero-visual__orbit--1 {
  width: 200px;
  height: 200px;
  animation: spin 20s linear infinite;
}

.hero-visual__orbit--2 {
  width: 280px;
  height: 280px;
  animation: spin 30s linear infinite reverse;
}

.hero-visual__orbit--3 {
  width: 360px;
  height: 360px;
  border-style: dashed;
  opacity: 0.5;
  animation: spin 40s linear infinite;
}

.hero-visual__core {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, rgba(0, 82, 217, 0.9), rgba(0, 163, 255, 0.8));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 40px rgba(0, 163, 255, 0.4), inset 0 0 20px rgba(255, 255, 255, 0.15);
  animation: float 5s ease-in-out infinite;
}

.hero-visual__core-inner {
  text-align: center;
  color: #fff;
}

.hero-visual__core-icon {
  display: block;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 1px;
}

.hero-visual__core-text {
  font-size: 12px;
  opacity: 0.9;
}

.hero-visual__chip {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.95);
  white-space: nowrap;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.hero-visual__chip-icon {
  font-size: 16px;
}

.hero-visual__chip--tl { top: 8%; left: 0; animation: float 4s ease-in-out infinite; }
.hero-visual__chip--tr { top: 12%; right: 0; animation: float 4.5s ease-in-out 0.5s infinite; }
.hero-visual__chip--bl { bottom: 18%; left: 4%; animation: float 5s ease-in-out 1s infinite; }
.hero-visual__chip--br { bottom: 12%; right: 0; animation: float 4.2s ease-in-out 0.3s infinite; }

.hero-visual__chart {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  opacity: 0.7;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes spin {
  from { transform: translate(-50%, -50%) rotate(0deg); }
  to { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes pulse-glow {
  0%, 100% { opacity: 0.6; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 1; transform: translate(-50%, -50%) scale(1.08); }
}

@media (max-width: 960px) {
  .hero-visual {
    height: 280px;
    max-width: 360px;
    margin-top: 16px;
  }

  .hero-visual__orbit--3 {
    width: 300px;
    height: 300px;
  }
}
</style>
